import React from "react"
import { XMarkIcon } from '@heroicons/react/24/solid';
import { Card, CardFooter, CardHeader, CardTitle, CardContent, CardDescription, CardAction, Button, Label, Input } from '../../shadcnComponents/ui'

export function NewFolderInput(props) {
    function handleCreate() {
        if (document.getElementById("folder-name").value != "") {
            props.createFolder();
            document.getElementById('folder-name').value = '';
            document.getElementById('folder-name').required = false
            document.getElementById('new-folder').classList.add('hidden');
        } else {
            document.getElementById("folder-name").required = true
        }
    }

    function closeDialogue() {
        document.getElementById('folder-name').value = '';
        document.getElementById('folder-name').required = false
        document.getElementById('new-folder').classList.add('hidden');
    }

    return (
        <div id='new-folder' className="hidden fixed z-10 w-screen h-screen top-0 left-0 bg-secondary-background flex items-center justify-center">
            <Card className='w-[40rem]'>
                <CardHeader>
                    <CardTitle>Νέος φάκελος</CardTitle>
                    <CardDescription>
                        Δώστε ένα όνομα για το νέο φάκελο
                    </CardDescription>
                    <CardAction>
                        <Button onClick={() => { closeDialogue() }} variant="link">
                            <XMarkIcon className='size-6' />
                        </Button>
                    </CardAction>
                </CardHeader>
                <CardContent>
                    <form>
                        <div className="flex flex-col gap-6">
                            <div className="grid gap-2">
                                <Label htmlFor="text">Όνομα</Label>
                                <Input
                                    onKeyDown={(e) => { if (e.key == 'Enter') { e.preventDefault(); handleCreate() } }}
                                    id="folder-name"
                                    type="text"
                                    placeholder="Όνομα φακέλου"
                                />
                            </div>
                        </div>
                    </form>
                </CardContent>
                <CardFooter className='gap-5 w-full justify-end'>
                    <Button onClick={() => { handleCreate() }} variant={'yes'} >
                        Δημιουργία
                    </Button>
                    <Button variant={'no'} onClick={() => { closeDialogue() }}>
                        Άκυρο
                    </Button>
                </CardFooter>
            </Card>
        </div>
    )
}

export default NewFolderInput